import { jsx as _jsx } from "react/jsx-runtime";
import { classNames, responsiveVariables, responsivePropDependency } from "../../utilities/props.js";
import getAlignStyles from "../../styles/align/index.js";
import getJustifyStyles from "../../styles/justify/index.js";
import s from "./Grid.module.css";
const GridItem = (props) => {
    const { area, colStart, colEnd, colSpan, rowStart, rowEnd, rowSpan, children, className, 
    // Using any here to let TS save on type resolving, otherwise TS throws an error due to the type complexity
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    as: TagName = "div", attributes, } = props;
    const itemClassNames = classNames(s.item, className);
    const resolvedColSpan = responsivePropDependency(colSpan, (value) => value && `span ${value}`);
    const resolvedRowSpan = responsivePropDependency(rowSpan, (value) => value && `span ${value}`);
    const rootVariables = {
        ...attributes?.style,
        ...responsiveVariables("--rs-grid-area", area),
        ...responsiveVariables("--rs-grid-col-end", resolvedColSpan),
        // both span and end use the same css variable but end has a higher prioerity
        ...responsiveVariables("--rs-grid-col-end", colEnd),
        ...responsiveVariables("--rs-grid-col-start", colStart),
        ...responsiveVariables("--rs-grid-row-end", resolvedRowSpan),
        ...responsiveVariables("--rs-grid-row-end", rowEnd),
        ...responsiveVariables("--rs-grid-row-start", rowStart),
    };
    return (_jsx(TagName, { ...attributes, className: itemClassNames, style: rootVariables, children: children }));
};
const Grid = (props) => {
    const { areas, columns, rows, gap, align, justify, autoColumns, autoRows, autoFlow, children, className, 
    // Using any here to let TS save on type resolving, otherwise TS throws an error due to the type complexity
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    as: TagName = "div", attributes, } = props;
    const alignStyles = getAlignStyles(align);
    const justifyStyles = getJustifyStyles(justify);
    const resolvedRows = responsivePropDependency(rows, (value) => typeof value === "number" ? `repeat(${value}, 1fr)` : value);
    const resolvedColumns = responsivePropDependency(columns, (value) => typeof value === "number" ? `repeat(${value}, 1fr)` : value);
    const resolvedAreas = responsivePropDependency(areas, (value) => value
        ? `"${value?.join('" "')}"
	`
        : undefined);
    const rootClassNames = classNames(s.root, className);
    const rootVariables = {
        ...attributes?.style,
        ...responsiveVariables("--rs-grid-gap", gap),
        ...responsiveVariables("--rs-grid-rows", resolvedRows),
        ...responsiveVariables("--rs-grid-columns", resolvedColumns),
        ...responsiveVariables("--rs-grid-areas", resolvedAreas),
        ...responsiveVariables("--rs-grid-auto-flow", autoFlow),
        ...responsiveVariables("--rs-grid-auto-columns", autoColumns),
        ...responsiveVariables("--rs-grid-auto-rows", autoRows),
        ...alignStyles?.variables,
        ...justifyStyles?.variables,
    };
    return (_jsx(TagName, { ...attributes, className: rootClassNames, style: rootVariables, children: children }));
};
Grid.Item = GridItem;
Grid.displayName = "Grid";
GridItem.displayName = "Grid.Item";
export default Grid;
